import React, { useContext } from 'react';
import { CharlyChatContext } from './CharlyChat';
import { ScrollPanel } from 'primereact/scrollpanel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPencil } from '@fortawesome/free-solid-svg-icons';
import ModalDeleteChat from './ModalForm/ModalDeleteChat';
import ModelCao from './ModalForm/ModelCao';

function CharlyChatList({ chats }) {
  const { chatId, setChatId, loadingChat, setChatCurrentPage, chatTotalCount, setChatToDeleteId, setAction, setShow, setMenuVisible, caoOption } = useContext(CharlyChatContext);

  function handleChatClick(id) {
    setChatId(id);
  }
  
  function handleDeleteChat(id) {
    setChatToDeleteId(id);
    setShow(true);
    setMenuVisible(false);
    setAction({action:'delete-chat', title: 'Chat verwijderen', size:'sm', component: <ModalDeleteChat/>});
  }

  return (
    <div
      className="d-flex flex-column position-relative"
      style={{
        height: 'calc(100vh - 115px)',
        overflow: 'hidden',
        opacity: loadingChat ? 0.6 : 1,
        pointerEvents: loadingChat ? 'none' : 'auto',
      }}
    >
      <div className="mb-3 p-2">
        <div className='flex'>
            <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => !loadingChat && (handleChatClick('new'), setMenuVisible(false))}
            >
            + Nieuwe Chat
            </button>

            <button
            className="btn btn-sm btn-outline-primary ml-3"
            onClick={() => { 
                setAction({action:'change-cao', title:'Waar ben je werkzaam?', size:'sm', component: <ModelCao/>}); 
                setShow(true); 
                setMenuVisible(false); 
            }}
            >
            <FontAwesomeIcon icon={faPencil} className='mr-1'/>
            Werklocatie: {caoOption}
            </button>
        </div>
        <h5 className="mb-0 mt-2">Jouw Chats</h5>
      </div>
      <div style={{ flex: 1, minHeight: 0 }}>
        <ScrollPanel style={{ width: '100%', height: '100%' }}>
          {chats && chats.length > 0 && (
            <ul className="list-group">
              {chats.map((c) => (
                <li
                  key={c.id}
                  onClick={() => !loadingChat && (handleChatClick(c.id), setMenuVisible(false))}
                  className={`list-group-item list-group-item-action ${c.id === chatId ? 'active' : ''}`}
                  role="button"
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                  <span>{c.title || 'Chat ' + c.id}</span>
                  <FontAwesomeIcon
                    icon={faTrash}
                    onClick={(e) => {
                      e.stopPropagation()
                      e.preventDefault();
                      handleDeleteChat(c.id);
                    }}
                    style={{ cursor: 'pointer', color: 'gray' }}
                  />
                </li>
              ))}
            </ul>
          )}
          {chats.length < chatTotalCount && (
            <div className="d-flex justify-content-center p-2">
              <button
                className="btn btn-link btn-sm text-muted"
                onClick={() => {
                  const nextChatPage = Math.floor(chats.length / 10) + 1;
                  setChatCurrentPage(nextChatPage);
                }}
              >
                Laad meer chats
              </button>
            </div>
          )}
        </ScrollPanel>
      </div>
    </div>
  );
}

export default CharlyChatList;
